import { render } from "./systems.vue?vue&type=template&id=1c60ddd1&ts=true"
import script from "./systems.vue?vue&type=script&lang=ts"
export * from "./systems.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__